import React, { Component } from 'react'
import { app } from "@microsoft/teams-js";
import jwt_decode from "jwt-decode";
import Utils from "./../common/Utils";

import './Login.scss'

export default class LoginResult extends Component {

    componentDidMount() {
        const redirectUrl = localStorage.getItem('postLoginRedirect') || '/';
        // This also runs inside ADAL's hidden token-renewal iframe, where we must not navigate
        const isTopWindow = window.self === window.top;

        // Remember the account the user picked, the silent token request has to name it
        try {
            const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
            const idToken = params.get("id_token");
            if (idToken && isTopWindow) {
                const claims = jwt_decode(idToken);
                const loginHint = claims.preferred_username || claims.upn || claims.email;
                if (loginHint) {
                    console.log("loginReply: account is " + loginHint);
                    Utils.lsSet("login_hint", loginHint);
                }
            }
        } catch (e) {
            console.log("loginReply: could not read the account from the id_token: " + e);
        }

        console.log("loginReply: Start");
        // Fallback f�r Nicht-Teams-Umgebung
        if (this.props.authContext.isCallback(window.location.hash)) {
            this.props.authContext.handleWindowCallback(window.location.hash);
            console.log("loginReply: Callback");
            if (this.props.authContext.getCachedUser()) {
                console.log("loginReply: Success");
                if (isTopWindow) {
                    window.location.href = redirectUrl; // Zur�ck zur Startseite oder gew�nschtem Ziel

                    localStorage.removeItem('postLoginRedirect');
                }
            } else {
                console.log("loginReply: Failure");
                if (isTopWindow) {
                    window.location.href = redirectUrl; // Optional: zur�ck zur Login-Seite
                }
            }
        } else {
            console.log("loginReply: UnexpectedFailure");
            if (isTopWindow) {
                window.location.href = redirectUrl; // Optional: zur�ck zur Login-Seite
            }
        }
        // Navigating the renewal iframe would boot a second copy of the app inside it
        if (!isTopWindow) {
            console.log("loginReply: handled inside the renewal iframe, not navigating");
        }

    }


    render() {
        return (
            <div className="login-body">
            </div>
        );
    }
}

